module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"loadError":"Data loading error. Reload the page or try again later."},"zh":{"loadError":"데이터 로드 오류입니다. 페이지를 새로고침하거나 나중에 다시 시도하세요."},"kr":{"loadError":"数据加载错误。 重新加载页面或稍后再试。"}}')
  delete Component.options._Ctor
}
